import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from './ListItem';
import { useFormListView } from '../../components/Form/ListForm';
// example of how 'remove' is added to another part of the page
export const ListView = (props) => {
    const items = useFormListView(props);
    return (_jsx("ul", { children: items.map((item) => (_jsx(ListItem, { item: item.item, index: item.index, onEdit: item.onEdit, onDelete: item.onDelete }, item.key))) }));
};
